import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Category } from '../types/contractor';
import { Province } from '../api/locations';

interface HeroSectionProps {
  categories: Category[];
  provinces: Province[];
}

const HeroSection: React.FC<HeroSectionProps> = ({ categories, provinces }) => {
  const navigate = useNavigate();
  const [categoryId, setCategoryId] = useState('');
  const [provinceId, setProvinceId] = useState('');

  const handleSearch = () => {
    const params = new URLSearchParams();
    if (categoryId) params.set('categoryId', categoryId);
    if (provinceId) params.set('provinceId', provinceId);
    navigate(`/contractors?${params.toString()}`);
  };

  return (
    <>
      {/* Mobile Hero */}
      <section className="md:hidden mt-16 px-container-margin space-y-stack-md pt-stack-lg">
        <div className="relative">
          <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-outline pointer-events-none z-10" data-icon="build">build</span>
          <select
            className="w-full pl-12 pr-4 py-4 bg-surface-container-lowest border border-outline-variant rounded-xl focus:border-primary focus:ring-1 focus:ring-primary outline-none font-body-md text-on-surface appearance-none"
            value={categoryId}
            onChange={e => setCategoryId(e.target.value)}
          >
            <option value="">All services</option>
            {categories.map(c => (
              <option key={c.id} value={c.id}>{c.name}</option>
            ))}
          </select>
        </div>
        <div className="relative">
          <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-outline pointer-events-none z-10" data-icon="location_on">location_on</span>
          <select
            className="w-full pl-12 pr-4 py-4 bg-surface-container-lowest border border-outline-variant rounded-xl focus:border-primary focus:ring-1 focus:ring-primary outline-none font-body-md text-on-surface appearance-none"
            value={provinceId}
            onChange={e => setProvinceId(e.target.value)}
          >
            <option value="">All provinces</option>
            {provinces.map(p => (
              <option key={p.id} value={p.id}>{p.name}</option>
            ))}
          </select>
        </div>
        <button
          onClick={handleSearch}
          className="w-full bg-secondary text-on-secondary py-4 rounded-xl font-headline-sm text-headline-sm hover:brightness-110 active:scale-95 transition-all"
        >
          Search
        </button>
      </section>

      {/* Desktop Hero */}
      <section className="hidden md:block hero-gradient py-24 px-container-margin text-center relative overflow-hidden bg-primary">
        <div className="max-w-4xl mx-auto relative z-10">
          <h1 className="font-display-lg text-display-lg text-white mb-6">Expert Help for Every Building Project</h1>
          <p className="font-body-lg text-body-lg text-white/80 mb-10 max-w-2xl mx-auto">
            Connecting property managers and homeowners with the most reliable, verified professionals in the construction industry.
          </p>
          <div className="glass-search p-2 rounded-xl shadow-2xl flex flex-col md:flex-row gap-2 max-w-3xl mx-auto bg-white">
            <div className="flex-1 flex items-center px-4 gap-3 border-r border-outline-variant/30">
              <span className="material-symbols-outlined text-outline flex-shrink-0" data-icon="build">build</span>
              <select
                className="w-full bg-transparent border-none focus:ring-0 font-body-md text-body-md text-on-surface appearance-none cursor-pointer"
                value={categoryId}
                onChange={e => setCategoryId(e.target.value)}
              >
                <option value="">What service do you need?</option>
                {categories.map(c => (
                  <option key={c.id} value={c.id}>{c.name}</option>
                ))}
              </select>
            </div>
            <div className="flex-1 flex items-center px-4 gap-3 border-r border-outline-variant/30">
              <span className="material-symbols-outlined text-outline flex-shrink-0" data-icon="location_on">location_on</span>
              <select
                className="w-full bg-transparent border-none focus:ring-0 font-body-md text-body-md text-on-surface appearance-none cursor-pointer"
                value={provinceId}
                onChange={e => setProvinceId(e.target.value)}
              >
                <option value="">Where are you located?</option>
                {provinces.map(p => (
                  <option key={p.id} value={p.id}>{p.name}</option>
                ))}
              </select>
            </div>
            <button
              onClick={handleSearch}
              className="bg-secondary text-on-secondary px-8 py-3 rounded-lg font-headline-sm text-headline-sm hover:brightness-110 active:scale-95 transition-all"
            >
              Search
            </button>
          </div>
        </div>
        <div className="absolute top-0 right-0 w-1/3 h-full opacity-10 pointer-events-none">
          <img
            alt="Architectural background"
            className="w-full h-full object-cover"
            src="https://lh3.googleusercontent.com/aida-public/AB6AXuBSamG7xbEuLXb3eWTZSg-_guaysYgsqkXQg3YCHMbdmiJ5KIu7VDyuVdjBTWzy9_NbobLdinn_cPx0Q5ZRvWt0gSZXkJUdhsDEaQOXIcn4adyFh18_x8ghg4dPeuI79qHe3yAKVcIH288SKwJSmA_5t_w24ylj228JRcS8HG4JvAYTV0S8zmfELGmntQQmgCzQNM-y_9Exp0G-S5_zejwzBhuAeQgxiGjv5kH5VFVScV8MmSaeHbIxMqEoUv-i-o8R08OyA4vx1PIQ"
          />
        </div>
      </section>
    </>
  );
};

export default HeroSection;
